export default __webpack_public_path__ + "static/media/temp.27660f5b.svg";